import React from 'react';
import {
  getCurrencySymbol,
  getItemDefaultBarcode,
  getItemPriceString,
  getVariantImageUrl,
} from '../../../../helpers';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

const Wrapper = styled.div`
  padding: 16px;
  background: white;
  display: flex;
  border-bottom: 1px solid #e3e5e7;

  &:last-of-type {
    border-bottom: none;
  }

  .right {
    flex-grow: 1;
    max-width: calc(100% - 66px);
  }

  .image-block {
    width: 50px;
    height: 50px;
    object-fit: cover;
    margin-right: 16px;
    border-radius: 4px;
  }

  .table-item-title {
    font-size: 12px;
    margin: 0;
  }

  .variant-toggle-span {
    color: #98a6ad;
    font-size: 11px;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .row-footer {
    display: flex;
    height: 20px;
    align-items: flex-end;
    margin-top: 8px;
  }

  .row-price {
    font-size: 12px;
    font-weight: 600;
  }

  .fe-chevron-right,
  .fe-chevron-down,
  .fe-plus,
  .fe-minus {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin: 0 !important;
    color: #7e57c2;
  }

  .chevron-td {
    margin-left: auto;
    position: relative;
    top: 3px;
  }

  .stock {
    margin-left: 15px;
    color: #98a6ad;
    font-size: 11px;
  }

  .footer-quantity-picker {
    margin-left: auto;

    .quantity-control {
      width: 20px;
      height: 20px;
    }
  }
`;

const VariantsTableMobile = (props) => {
  const {
    features,
    variants,
    variantsValidation,
    selectedVariants,
    handleSelectVariant,
    updateVariant,
    deleteVariant,
    deleteLoading,
    openVariant,
  } = props;

  const { checkoutSettings } = useSelector((state) => state.settings);

  return (
    <div>
      {variants.map((variant) => (
        <Wrapper key={variant.id} className="variant-row" onClick={() => openVariant(variant)}>
          <img
            className="image-block"
            src={getVariantImageUrl(variant, 100)}
            alt={variant.shortName}
          />
          <div className="right">
            <div className="table-item-title">
              {variant.optionsUsed?.map((o) => o.stringValue).join(' ')}
            </div>
            <div className="variant-toggle-span">
              {variant.id} {variant.extId ? `(${variant.extId})` : null}
              <br />
              {variant.article}
              <br />
              {getItemDefaultBarcode(variant) ? getItemDefaultBarcode(variant).value : null}
            </div>
            <div className="row-footer">
              <div style={{ whiteSpace: `nowrap` }} className="row-price">
                {variant.price} {getCurrencySymbol(checkoutSettings.currency)}
              </div>
            </div>
          </div>
        </Wrapper>
      ))}
    </div>
  );
};

export default VariantsTableMobile;
